import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@icg360/ui-toolkit";

var ClearFormControl = function ClearFormControl(_ref) {
  var children = _ref.children,
      dataBdd = _ref.dataBdd,
      onClear = _ref.onClear,
      shouldHideButton = _ref.shouldHideButton;

  var handleClear = function handleClear(event) {
    onClear(event);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "clear-form-container"
  }, children, !shouldHideButton && /*#__PURE__*/React.createElement("button", {
    "data-bdd": dataBdd,
    className: "clear-form-control",
    onClick: handleClear,
    type: "button"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "clear",
    size: "sm"
  })), /*#__PURE__*/React.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "\n                .clear-form-container {\n                    position: relative;\n                    display: flex;\n                }\n                .clear-form-container input {\n                    padding-right: 46px;\n                }\n                .clear-form-control {\n                    position: absolute;\n                    right: 0;\n                    top: 0;\n                    height: 100%;\n                    width: 34px;\n                    background: transparent;\n                    border: 0;\n                    padding: 0;\n                    text-align: center;\n                    opacity: 0.3;\n                    transition: opacity 0.2s;\n                    z-index: 3;\n                }\n            "
    }
  }));
};

ClearFormControl.propTypes = {
  children: PropTypes.node.isRequired,
  dataBdd: PropTypes.string,
  onClear: PropTypes.func.isRequired,
  shouldHideButton: PropTypes.bool
};
export default ClearFormControl;